export abstract class RecordingInfoPanel {

	protected infoPanel: JQuery;

	constructor(infoPanel: JQuery) {
		this.infoPanel = infoPanel;
	}

	public abstract isVisible(): boolean;

	/**
	 * Updates the visibility of the infoPanel container
	 * The container will be shown if a contained field is visible (TipField and InfoField)
	 * @protected
	 */
	protected onVisibilityChanged() {
		this.infoPanel.toggle(this.isVisible());
	}
}
